export default __webpack_public_path__ + "static/media/bin.acb2803b.svg";